import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// API to fetch Z Report data
export const getZReport = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/DayClosing/get-z-report`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Z Report:", error);
    throw error;
  }
};

// API to export Z Report to Excel
export const exportZReportToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/DayClosing/export-z-report-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const dateStr = filter.fromDate ? new Date(filter.fromDate).toISOString().slice(0,10).replace(/-/g, '') : '';
    const toDateStr = filter.toDate ? new Date(filter.toDate).toISOString().slice(0,10).replace(/-/g, '') : '';
    link.setAttribute('download', `Z_Report_${dateStr}_${toDateStr}_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting Z Report:", error);
    throw error;
  }
};

